/**
 * Loadable
 *
 * @mixin
 */
export default {
  data() {
    return {
      loading: false,
      loadingCount: 0,
    };
  },

  methods: {
    loadingStart() {
      this.loadingCount += 1;
      this.loading = true;
      this.$emit('load', true);
    },
    loadingFinish() {
      this.loadingCount = Math.max(this.loadingCount - 1, 0);
      if (this.loadingCount === 0) {
        setTimeout(() => {
          this.loading = false;
          this.$emit('load', false);
        }, 275);
      }
    },
  },
};
